import React, { useContext, useEffect, useRef, useState } from 'react';
import { graphql } from 'gatsby';
import * as styles from './sitemap.module.css';
import SitemapComp from './SitemapComp';
import { PageMetadataContext } from '../../templates/PageMetaDataContext';

interface Props {
    kontentItemId?: string;
}

const Sitemap: React.FC<Props> = ({ kontentItemId }) => {
    const pageMetadata = useContext(PageMetadataContext);
    const preferredLanguage = pageMetadata.preferredLanguage?.toLowerCase();
    const componentRef = useRef<HTMLDivElement>(null);
    const [showButton, setShowButton] = useState(false);
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 1200) {
                setShowButton(true);
            } else {
                setShowButton(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToTop = () => {
        if (componentRef.current) {
            const top =
                componentRef.current.getBoundingClientRect().top +
                window.scrollY;
            window.scrollTo({ top: top - 100, behavior: 'smooth' });
        }
    };

    return (
        <div
            className={styles.wrapper}
            ref={componentRef}
            data-kontent-item-id={kontentItemId}
        >
            <SitemapComp />
            {showButton &&
                (preferredLanguage === 'au-en' ||
                preferredLanguage === 'nz-en' ? (
                    <button
                        onClick={scrollToTop}
                        className={styles.scrollToTopButton}
                        aria-label="Scroll to top"
                    >
                        ↑
                    </button>
                ) : (
                    <a
                        href="#selectcountry"
                        className={styles.scrollToTopButton}
                        aria-label="Scroll to top"
                    >
                        ↑
                    </a>
                ))}
        </div>
    );
};

export default Sitemap;

export const fragmentSitemap = graphql`
    fragment Sitemap on kontent_item_component___sitemap {
        system {
            id
        }
    }
`;
